<template>
  <div class="gridBox"
      :class="columns ? 'gridBox__row' : 'gridBox__column'"
      :style="columns ? {'grid-template-columns': `repeat(${columns}, minmax(0, 1fr))`} : {'grid-template-rows': `repeat(${rows}, minmax(0, 1fr))`}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'GridBox',
  props: {
    columns: {
      type: [String],
    },
    rows: {
      type: [String],
    },
  },
};
</script>

<style lang="scss" scoped>
.gridBox {
  width: 100%;

  @include pad-width() {
    display: grid;

    &__column {
      grid-auto-flow: column;
    }

    &__row {
      grid-auto-flow: row;
    }
  }
}
</style>
